module.exports = __webpack_public_path__ + "img/FI15977295.fc17d20e.png";